import React from 'react';
import { getNoteDurationSpriteCoordinates } from '../../render/renderUtils';
import { NoteDuration } from '../../model/core';

function RydNoteDurationImage({ duration }: { duration: NoteDuration }) {
    const spriteCoordinates: { x: number, y: number } = getNoteDurationSpriteCoordinates(duration);
    return (
        <div style={{
            background: `url('note-durations-sprite.png') ${spriteCoordinates.x}px ${spriteCoordinates.y}px`,
            width: 22,
            height: 67,
            display: 'inline-block',
        }} />);
}

export default RydNoteDurationImage;